import { createElement } from "@wordpress/element";
/**
 * External dependencies
 */
import { RgbStringColorPicker, RgbaStringColorPicker } from 'react-colorful';
import { colord } from 'colord';

/**
 * WordPress dependencies
 */
import { useMemo } from '@wordpress/element';
/**
 * Internal dependencies
 */

export const Picker = ({
  color,
  enableAlpha,
  onChange
}) => {
  const Component = enableAlpha ? RgbaStringColorPicker : RgbStringColorPicker;
  const rgbColor = useMemo(() => color.toRgbString(), [color]);
  return createElement(Component, {
    color: rgbColor,
    onChange: nextColor => {
      onChange(colord(nextColor));
    }
  });
};
//# sourceMappingURL=picker.js.map